var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A19",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 0h85v85H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M84.999 60.927H80.452l-.762-1.276h3.06l-9.548-15.982.727-1.218-2.258 3.778 8.781 14.698h-1.487l-8.038-13.453-.746-1.246 13.283-22.229h1.492L73.945 42.424l11.054 18.503zm-28.148-.017l22.055-36.911h1.488L58.34 60.91h-1.489zm11.8-24.855l-6.44-10.78h-3.06l7.227 12.097.743 1.246-13.33 22.309h-1.487l11.671-19.533-.617 1.03-11.01-18.425h1.492l10.264 17.178 1.531-2.561-8.732-14.617H62.937l5.715 9.566 5.717-9.566h1.486l-6.46 10.811-.744 1.245zM45.81 25.274h-2.629v35.653h-5.184V23.999h1.278v35.682h2.628V23.999h5.183v36.928H45.81V25.274zM16.37 61C7.343 61 0 53.674 0 44.669v-20.67h1.292v20.67c0 8.293 6.763 15.04 15.078 15.04 8.313 0 15.075-6.747 15.075-15.04V25.274h-2.491v19.058c0 6.925-5.645 12.558-12.584 12.558-6.941 0-12.586-5.633-12.586-12.558V23.999h5.272v20.194c0 4.024 3.282 7.296 7.314 7.296s7.31-3.272 7.31-7.296V23.999h1.294v20.194c0 4.735-3.861 8.585-8.604 8.585-4.746 0-8.606-3.85-8.606-8.585V25.274H5.077v19.058c0 6.214 5.065 11.267 11.293 11.267 6.226 0 11.291-5.053 11.291-11.267V23.999h5.077v20.67C32.738 53.674 25.397 61 16.37 61zm53.027-10.964l6.506 10.891h-1.486l-5.765-9.644-5.766 9.644H61.4l7.251-12.138.746 1.247z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteIcon);
export default __webpack_public_path__ + "static/media/logo-white-icon.6a11e48f8b1725e1147781fc94871bc7.svg";
export { ForwardRef as ReactComponent };